import { render, staticRenderFns } from "./ReportConfiguration.vue?vue&type=template&id=70e037be&"
import script from "./ReportConfiguration.vue?vue&type=script&lang=js&"
export * from "./ReportConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ReportConfiguration.vue?vue&type=style&index=0&id=70e037be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports